
/**
 * @export
 * @enum {string}
 */
export enum McpLimitActionType {
    ACCOUNT_LIMIT_CREATE = 'ACCOUNT_LIMIT_CREATE',
    USER_LIMIT_CREATE = 'USER_LIMIT_CREATE',
    TEMPORARY_USER_LIMIT_CREATE = 'TEMPORARY_USER_LIMIT_CREATE',
    TEMPORARY_ACCOUNT_LIMIT_CREATE = 'TEMPORARY_ACCOUNT_LIMIT_CREATE',
    TEMPORARY_USER_LIMIT_UPDATE = 'TEMPORARY_USER_LIMIT_UPDATE',
    TEMPORARY_ACCOUNT_LIMIT_UPDATE = 'TEMPORARY_ACCOUNT_LIMIT_UPDATE',
    USER_LIMIT_UPDATE = 'USER_LIMIT_UPDATE',
    ACCOUNT_LIMIT_UPDATE = 'ACCOUNT_LIMIT_UPDATE'
}